import React from "react";
import { Block } from "@randajan/jet-react/dom/block";

import { Profile } from "../../frames/Profile/Profile";

import "./Whois.scss";
import { Router } from "..";

export const Whois = _=>{
    const { path, params:{ aliasKey } } = Router.useRoute();

    return <Profile className="Whois" aliasKey={aliasKey}/>;
};
